/* eslint-disable */
import React, { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import games from '../simsSerway.json'
import { useRef, useState } from 'react'
import useRuffle from '../components/scripts/useRuffle'
import { AiOutlineArrowLeft } from 'react-icons/ai'
import useEmbedded from '../hooks/useEmbedded'
function Play() {
  const { id } = useParams()
  const navigate = useNavigate()
  const embedded = useEmbedded()
  const game = games.find(game => game.title === id)
  if (!game) {
    return <div>Simulation not found</div>
  }
  const source = `/swf/${game.title}.swf`
  const width = '100%'
  const height = '100%'
  const ruffleContainer = useRef(null)
  useRuffle(ruffleContainer, source, width, height)

  return (
    <div className="flex shrink w-full h-screen justify-center items-center bg-white text-gray-900 dark:bg-[#1A202C] dark:text-gray-100">
      {!embedded && (
        <AiOutlineArrowLeft
          className="fixed z-50 m-2 top-0 left-0 text-3xl text-gray-900 transition-colors hover:cursor-pointer dark:text-gray-100"
          onClick={() => {
            navigate('/')
          }}
        />
      )}
      <div className="flex flex-col w-full h-full items-center justify-center mt-0">
        <div ref={ruffleContainer} className="w-full h-full flex justify-center items-center"></div>
      </div>
    </div>
  )
}

export default Play
